import { Card, Col, Container, Row } from "react-bootstrap";
import { DashboardMetric } from "..";
import { useNavigate } from "react-router-dom";
import { Icon, LoadingSpinner, fas } from "../../../component-library";
import { useRecoveryQuery } from "../../../queries";
import { Lists } from "../../lists";

export function RecoveryDashboard() {
    const navigate = useNavigate();
    const { dashboardQuery } = useRecoveryQuery();
    const { data } = dashboardQuery;

    if (dashboardQuery.isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <h1>Recovery Dashboard</h1>

            <Row className="gx-3 mb-3">
                <Col>
                    <Card>
                        <Card.Body className="bg-canvas">
                            <Row>
                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                Active Referrals{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Referrals with a status of Consent Pending"
                                                    aria-label="Referrals with a status of Consent Pending"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.activeReferrals ?? "-"}
                                        onClick={() => navigate(`/lists/${Lists.ReferralsActive}/cases`)}
                                    />
                                </Col>
                                <Col>
                                    <DashboardMetric
                                        title="Pending Recoveries"
                                        value={data?.pendingRecoveries ?? "-"}
                                        onClick={() => navigate(`/lists/${Lists.DonorsRecoveriesPending}/cases`)}
                                    />
                                </Col>
                                <Col>
                                    <DashboardMetric
                                        title="Incoming Recovered"
                                        value={data?.incomingRecoveredTissues}
                                        onClick={() => navigate(`/lists/${Lists.DonorsIncomingRecovered}/cases`)}
                                    />
                                </Col>
                                <Col>
                                    <DashboardMetric
                                        title={
                                            <span>
                                                Failed Recovery Syncs{" "}
                                                <Icon
                                                    icon={fas.faInfoCircle}
                                                    title="Recovery app data without a matched donor"
                                                    aria-label="Recovery app data without a matched donor"
                                                    className="text-primary"
                                                />
                                            </span>
                                        }
                                        value={data?.failedRecoverySyncs ?? "-"}
                                        onClick={() => navigate("/failed-recovery-syncs")}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
